"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_VERSION = exports.PKG_VERSION = exports.PKG_NAME = void 0;
exports.PKG_NAME = "@hpcc-js/dgrid-shim";
exports.PKG_VERSION = "3.5.2";
exports.BUILD_VERSION = "3.5.2";
//# sourceMappingURL=__package__.js.map